import {ConfigService, RunConfigService} from '@nuskin/ns-util';

import axios from 'axios';

/**
 * The validation service will be called to validate components
 * @namespace validationService
 */
export default {
    validateTaxId
};


//=================================================================//
//
//  PUBLIC FUNCTIONS
//
//=================================================================//


const reqbodytemplate = {
    "market": "sg",
    "type": "personal",
    "value": "test",
    "evaluate": false
};
const taxValidationURL = RunConfigService.getEnvironmentCode() === 'prod' 
    ? 'https://api.cloud.nuskin.com/componentFieldValidator/v1/validation/tax' : 'https://testapi.cloud.nuskin.com/componentFieldValidator/v1/validation/tax';

async function validateTaxId(market, type, value, evaluate) {
    reqbodytemplate.market = market;
    reqbodytemplate.type = type;
    reqbodytemplate.value = value;
    reqbodytemplate.evaluate = evaluate;
    let config;
    try {
        config = ConfigService.getMarketConfig();
    } catch(e) {
        // config = userDefinedConfig;
    }
    try {
        return await axios({
            method: 'POST',
            url:taxValidationURL,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'client_id': config.checkout.clientId,
                'client': 'aem'
            },
            data: JSON.stringify(reqbodytemplate),
            responseType: 'json'
        });
    } catch(e) {
        console.error("validateTaxId exception: " , e);
    }
}
